/** Number formatting and good/bad colouring for workshop metrics. A metric's
 *  `better` ("lower" | "higher") decides whether a change is an improvement. */

const MINUS = '−';

export function fmtChange(value, unit) {
  if (value == null) return '—';
  if (value === 0) return unit === 'pp' ? '0 pp' : '0%';
  const sign = value < 0 ? MINUS : '+';
  const abs = Math.abs(value);
  const n = Number.isInteger(abs) ? String(abs) : abs.toFixed(1);
  return unit === 'pp' ? `${sign}${n} pp` : `${sign}${n}%`;
}

/** 'good' | 'bad' | 'neutral' for a change in a metric. */
export function tone(value, better) {
  if (value == null || value === 0) return 'neutral';
  const improves = better === 'lower' ? value < 0 : value > 0;
  return improves ? 'good' : 'bad';
}

export const metricById = (workshop) =>
  Object.fromEntries(workshop.metrics.map((m) => [m.id, m]));
